/**
 * Shared styles and motion config for auth forms (Login, Register, Forgot Password, Change Password, OTP).
 */
import type { SxProps, Theme } from "@mui/material";

export const AUTH_CARD_RADIUS = 12;
export const AUTH_INPUT_RADIUS = 8;

export const authFormCardSx: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  p: { xs: 3, sm: 5, md: 6 },
  margin: "auto",
  position: "relative",
  width: "100%",
  maxWidth: { xs: "100%", sm: "100%", md: 520 },
  borderRadius: AUTH_CARD_RADIUS,
  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  border: "1px solid",
  borderColor: "divider",
  backgroundColor: "background.paper",
  overflow: "hidden"
};

export const authFormInputSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    borderRadius: `${AUTH_INPUT_RADIUS}px`,
    transition: "border-color 0.15s ease",
    "& fieldset": { borderRadius: `${AUTH_INPUT_RADIUS}px` },
    "&.Mui-focused fieldset": { borderWidth: "1px" }
  }
};

export const authFormCardMotion = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4, ease: "easeOut" as const }
};

export const authFormStagger = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.06,
      delayChildren: 0.1
    }
  }
};

export const authFormItemMotion = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.3, ease: "easeOut" as const }
};
